import React from 'react'
import ViewerOptions from './ViewerOptions'
import OwnerView from './OwnerView'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import {withRouter} from 'react-router'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import isAdmin from 'App/Decorators/isAdmin'

@isAdmin
@withGraphQL(gql`
  query me {
    me {
      _id
      email
    }
  }
`)
@withRouter
export default class SendToSign extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    document: PropTypes.object,
    organization: PropTypes.object,
    me: PropTypes.func,
    admin: PropTypes.string,
    url: PropTypes.bool,
    params: PropTypes.object
  }

  static fragment = gql`
    fragment documentSendToSign on Document {
      fieldsAssigned
      mySignOnly
    }
  `

  state = {}

  render() {
    if (
      this.props.document.documentOwner ||
      (this.props.organization && this.props.organization.myRole === 'owner') ||
      this.props.url
    ) {
      return (
        <OwnerView
          document={this.props.document}
          organization={this.props.organization}
          url={this.props.url}
        />
      )
    } else if (!this.props.document.documentOwner) {
      return (
        <ViewerOptions
          document={this.props.document}
          organization={this.props.organization}
          url={this.props.url}
        />
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/SendToSign/index.js